// extracted by mini-css-extract-plugin
module.exports = {"formBox":"RsoForm_formBox__png3f","containerPreview":"RsoForm_containerPreview__1F3ln","boxWizard":"RsoForm_boxWizard__3Pp6Q"};